import { Icon, Text, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React, { useMemo } from 'react';
import { Pressable } from 'react-native';
import { useRecoilValue } from 'recoil';

import { homeGlobalState } from '../../../../../../store/home/capture/atom';

import { CheckingAccountItemTypes } from '.';

export const CheckingAccountItemMobile: React.FC<CheckingAccountItemTypes.Props> = ({
  item,
  onSelectAccount,
}) => {
  const { valueVisibility } = useRecoilValue(homeGlobalState);
  const isValuePositive = item.operationValueNormalized > 0;

  const balanceColor = useMemo(() => {
    if (!valueVisibility) {
      return 'neutral.darkest';
    }

    return isValuePositive ? 'feedback.success.default' : 'feedback.error.default';
  }, [isValuePositive, valueVisibility]);

  return (
    <>
      <Box width="full" paddingBottom={Spacing['inline.xxs']}>
        <HStack justifyContent={'space-between'}>
          <HStack alignItems={'center'} justifyContent={'space-between'}>
            <Text variant="semibold" fontSize={Typography['fontsize.md']}>
              {isValuePositive ? 'ENTRADA' : 'SAÍDA'}
            </Text>
            <Icon
              name={isValuePositive ? 'ArrowDown' : 'ArrowUp'}
              color={Color[isValuePositive ? 'feedback.success.default' : 'feedback.error.default']}
              size="xxxs"
            />
          </HStack>

          <HStack alignItems={'center'} justifyContent={'space-between'}>
            {valueVisibility ? (
              <Icon
                name={isValuePositive ? 'ArrowDown' : 'ArrowUp'}
                color={
                  Color[isValuePositive ? 'feedback.success.default' : 'feedback.error.default']
                }
                size="xxxs"
              />
            ) : null}
            <Text
              color={balanceColor}
              variant="semibold"
              fontSize={valueVisibility ? Typography['fontsize.md'] : Typography['fontsize.xxs']}
              letterSpacing={valueVisibility ? undefined : Typography['bullet.spacing']}>
              {valueVisibility
                ? Utils.Mask.Money(item.operationValueNormalized)
                : Typography['bullet.sequence']}
            </Text>
          </HStack>
        </HStack>
        <Pressable onPress={() => onSelectAccount(item.customerAccountNumber)}>
          <Text fontSize={Typography['fontsize.md']}>{item.customerNameNormalized}</Text>
        </Pressable>
      </Box>
    </>
  );
};
